export default __webpack_public_path__ + "static/media/4992.eb93ee3b.png";